import React from 'react';

export const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="tcmf-footer">
            <div className="tcmf-footer-container">
                <div className="tcmf-footer-grid">
                    <div className="tcmf-footer-column">
                        <h3>TCMF Resources</h3>
                        <ul className="tcmf-footer-links">
                            <li>
                                <a href="https://tcmf-handbook.deplide.org/introduction.html" target="_blank"
                                   rel="noopener noreferrer">
                                    Introduction
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="tcmf-footer-column">
                        <h3>Tools</h3>
                        <ul className="tcmf-footer-links">
                            <li>
                                <a href="/" className="font-semibold">
                                    TCMF Generator
                                </a>
                            </li>
                            <li>
                                <a href="/#template" onClick={(e) => {
                                    e.preventDefault();
                                    document.getElementById('template-section')?.scrollIntoView({behavior: 'smooth'});
                                }}>
                                    Download Template
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="tcmf-footer-bottom">
                    <p className="text-left">
                        <a href="https://www.linkedin.com/company/rise-research-institutes-of-sweden/" target="_blank" rel="noopener noreferrer" className="mr-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="inline-block" viewBox="0 0 16 16">
                                <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"/>
                            </svg>
                        </a>
                        Copyright © {currentYear} <a href="https://ri.se/en">RISE Research Institutes of Sweden</a>
                    </p>
                </div>
            </div>
        </footer>
    );
};